import { Tooltip, TruncateText } from '@panwds/react-ui';
import React from 'react';
import { metricsHelper } from '../../../utils/metricsHelper.js';
import { useNavigationContextV3 } from '../NavigationContextV3/NavigationContextV3.js';
import { getSubNavListActionClasses, getSubNavListActionsContainerClasses, getSubNavListActionWrapClasses, getSubNavListButtonClasses, getSubNavListRootClasses } from './subNavListItem.logic.js';
export const NavLinkV3 = (props) => {
    const { dataMetrics, dataTestId, id, title, url, className, disabled, tooltip, primaryAction, secondaryAction } = props;
    const { flyoutId, collapsed, selectedSubNav, onNavigate, setState } = useNavigationContextV3();
    const isSelected = id === selectedSubNav;
    const match = !disabled && isSelected;
    const nonParentMatch = !disabled && isSelected;
    const onClickAction = () => {
        if (url)
            onNavigate?.({ id, title, url });
        if (flyoutId && collapsed) {
            setTimeout(() => {
                setState((prev) => ({
                    ...prev,
                    flyoutId: undefined,
                    visitedNav: undefined,
                    flyOutRef: undefined
                }));
            }, 1000);
        }
        setState((prev) => ({
            ...prev,
            visitedNav: undefined,
            selectedNav: prev.visitedNav ?? prev.selectedNav,
            selectedNavUrl: undefined,
            selectedSubNav: id,
            selectedSubNavUrl: url
        }));
    };
    const normalizedId = metricsHelper(id);
    const handleSecondaryAction = (e) => {
        e.stopPropagation();
        secondaryAction?.onClick?.({
            id,
            title,
            url,
            className,
            disabled
        });
    };
    const handlePrimaryAction = (e) => {
        e.stopPropagation();
        primaryAction?.onClick?.({
            id,
            title,
            url,
            className,
            disabled
        });
    };
    const renderListItem = () => {
        return (React.createElement("li", { className: getSubNavListRootClasses() },
            React.createElement("button", { id: `navigation-${normalizedId}`, "aria-expanded": match, "aria-controls": `navigation-item-${normalizedId}`, "data-metrics": dataMetrics || `navigation-${normalizedId}`, "data-testid": dataTestId || `navigation-${id}`, "data-url": url, className: getSubNavListButtonClasses(match, nonParentMatch, className, disabled), onClick: onClickAction, type: "button", disabled: disabled },
                React.createElement("div", { className: getSubNavListActionsContainerClasses() },
                    React.createElement(TruncateText, null,
                        React.createElement("span", null, title)),
                    React.createElement("div", { className: getSubNavListActionWrapClasses(!!primaryAction?.icon, !!secondaryAction?.icon) },
                        React.createElement("div", { className: getSubNavListActionClasses(!!secondaryAction?.icon), onClick: handleSecondaryAction, onKeyDown: (e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    handleSecondaryAction(e);
                                }
                            }, tabIndex: 0, role: "button" }, secondaryAction?.tooltip ? (React.createElement(Tooltip, { defaultPlacement: "top", singleLine: true, label: secondaryAction?.tooltip }, secondaryAction?.icon)) : (secondaryAction?.icon)),
                        React.createElement("div", { className: getSubNavListActionClasses(!!primaryAction?.icon), onClick: handlePrimaryAction, onKeyDown: (e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    handlePrimaryAction(e);
                                }
                            }, tabIndex: 0, role: "button" }, primaryAction?.tooltip ? (React.createElement(Tooltip, { defaultPlacement: "top", singleLine: true, label: primaryAction?.tooltip }, primaryAction?.icon)) : (primaryAction?.icon)))))));
    };
    return React.createElement(React.Fragment, null, tooltip ? React.createElement(Tooltip, { label: tooltip }, renderListItem()) : renderListItem());
};
//# sourceMappingURL=NavLinkV3.js.map